import { createFileRoute } from "@tanstack/react-router";

import BookingTimePage from "@/admin/settings/booking-time/page";

export const Route = createFileRoute("/app/$storeId/settings/booking-time")({
    component: RouteComponent,
});

function RouteComponent() {
    return <BookingTimePage />;
}
